import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const TxtIcon = ({ color = '#accff3', text = 'TXT' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default TxtIcon;
